// App.js
import React, { useState } from 'react';
import { Link, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import NewNavbar from './NewNavbar';

// ---------- Core pages ----------
import Home from './pages/Home/Home';
import Faculties from './pages/Faculties/Faculties';
import About from './pages/About/About';
import Blog from './pages/Blog/Blog';
import Contact from './pages/Contact/Contact';

// ---------- Auth / profiles ----------
import FacultyLogin from './components/FacultyLogin';
import ChangePassword from './components/ChangePassword';
import PrivateRoute from './components/PrivateRoute';
import FacultyRegister from './components/FacultyRegister';
import FacultyProfile from './components/FacultyProfile';
import FacultyProfileDetails from './components/FacultyProfileDetails';
import FacultyIndividual from './components/FacultyIndividual';

// ---------- Faculty directory views ----------
import FacultyDirectory from './components/FacultyDirectory';
import FacultyList from './components/FacultyList';

// ---------- Admin & uploads ----------
import AdminPanel from './components/AdminPanel';
import SliderImageUpload from './components/SliderImageUpload';
import AllImagesPage from './components/AllImagesPage';

// ---------- Departments ----------
import Departments from './components/Departments';
import DepartmentFaculty from './components/DepartmentFaculty';
import DepartmentDashboard from './components/DepartmentDashboard';
import DeptAllItems from './components/DeptAllItems';

// ---------- Faculty pages ----------
import FoCM from './pages/Faculties/FoCM';
import FEECE from './pages/Faculties/FEECE';
import FoS from './pages/Faculties/FoS';
import FoEE from './pages/Faculties/FoEE';
import FoT from './pages/Faculties/FoT';

function App() {
  const [stickyClass, setStickyClass] = useState('');
  const location = useLocation();

  // Hide the global navbar on any "/department..." or "/departments..." route
  const hideNavbar =
    location.pathname.startsWith('/department') ||
    location.pathname.startsWith('/departments');

  return (
    <div>
      {/* only show the main navbar when NOT on department pages */}
      {!hideNavbar && <NewNavbar />}

      <Routes>
        {/* ---------- General routes ---------- */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/faculties" element={<Faculties />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />

        {/* ---------- Auth ---------- */}
        <Route path="/login" element={<FacultyLogin />} />
        <Route path="/facultylogin" element={<FacultyLogin />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/facultyregister" element={<FacultyRegister />} />

        {/* ---------- Faculty directory ---------- */}
        <Route path="/faculty-directory" element={<FacultyDirectory />} />
        <Route path="/facultydirectory" element={<FacultyDirectory />} />

        {/* ---------- Faculty public profiles ---------- */}
        <Route path="/faculty-individual/:facultyUsername" element={<FacultyIndividual />} />
        <Route path="/faculty/:facultyUsername" element={<FacultyProfileDetails />} />

        {/* ---------- Protected faculty profile ---------- */}
        <Route element={<PrivateRoute />}>
          <Route path="/faculty-profile/:id" element={<FacultyProfile />} />
        </Route>

        {/* ---------- Department routes (all use your Departments layout) ---------- */}
        <Route path="/departments/*" element={<Departments />} />
        <Route path="/department/:id" element={<Departments />} />
        <Route path="/department/:id/faculty" element={<DepartmentFaculty />} />
        <Route path="/department-dashboard/:id" element={<DepartmentDashboard />} />
        <Route path="/department/:id/all/:type" element={<DeptAllItems />} />

        {/* ---------- Other Faculty pages ---------- */}
        <Route path="/focm" element={<FoCM />} />
        <Route path="/feece" element={<FEECE />} />
        <Route path="/fos" element={<FoS />} />
        <Route path="/foee" element={<FoEE />} />
        <Route path="/fot" element={<FoT />} />

        {/* ---------- Admin & uploads ---------- */}
        <Route path="/upload-slider-images" element={<SliderImageUpload />} />
        <Route path="/admin-panel" element={<AdminPanel />} />
        <Route path="/all-images" element={<AllImagesPage />} />

        {/* ---------- Admin faculty management ---------- */}
        <Route path="/admin-panel/faculty-list" element={<FacultyList />} />
        <Route path="/admin/faculty-list" element={<FacultyList />} />
      </Routes>

      {/* ---------- Footer ---------- */}
      <footer style={{ backgroundColor: '#142651', color: '#ffffff', padding: '20px 0' }}>
        <div className="container">
          <div className="row">
            {/* Quick links */}
            <div className="col-md-4 text-start">
              <h5 className="headings">QUICK LINKS</h5>
              <ul className="list-unstyled">
                <Link to="/" className="text-decoration-none text-danger">
                  <li className="footer-link list">Home</li>
                </Link>
                <Link to="/admissions" className="text-decoration-none text-danger">
                  <li className="footer-link list">Admissions</li>
                </Link>
                <Link to="/Scholarships" className="text-decoration-none text-danger">
                  <li className="footer-link list">Scholarships</li>
                </Link>
                <Link to="/faculties" className="text-decoration-none text-danger">
                  <li className="footer-link list">Our facilities</li>
                </Link>
                <Link to="/about" className="text-decoration-none text-danger">
                  <li className="footer-link list">About us</li>
                </Link>
              </ul>
            </div>

            {/* Contacts */}
            <div className="col-md-4 text-start">
              <h5 className="headings">CONTACTS</h5>
              <ul className="list-unstyled">
                <li className="list">
                  Quaid-e-Awam University<br />
                  Sakrand Road, Nawabshah, Sindh, Pakistan
                </li>
                <li className="list">Ph#: 0244-9370381-5</li>
                <li className="list">www.quest.edu.pk</li>
              </ul>
            </div>

            {/* Logo */}
            <div className="col-12 col-md-4 d-flex align-items-center">
              <img src="/images/mono1.png" alt="Quaid-e-Awam University" width="100" className="me-3" />
              <h5 className="logo">
                Quaid-E-Awam University of Engineering and Technology, Nawabshah
              </h5>
            </div>
          </div>

          <hr style={{ backgroundColor: '#ffffff' }} />

          <div className="text-center">
            <p>© 2025 Quaid-e-Awam University – All rights reserved</p>
            <p>
              <Link to="/privacy" style={{ color: '#ffffff' }}>Privacy</Link> |{' '}
              <Link to="/about" style={{ color: '#ffffff' }}>About this site</Link>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
